import { MOVIE_REQUEST, MOVIE_SUCCESS, MOVIE_FAILURE, CLEAR_MOVIE } from "./types";
import axios from "axios";
import { apikey } from "../../apikey";

export const fetchMovie = (imdbID) => async (dispatch) => {
  dispatch({ type: MOVIE_REQUEST });
  try {
    const res = await axios.get(
      `https://www.omdbapi.com/?apikey=${apikey}&i=${imdbID}&plot=full`
    );
    if (res.data.Response === "True") {
      dispatch({ type: MOVIE_SUCCESS, payload: res.data });
    } else {
      dispatch({ type: MOVIE_FAILURE, payload: res.data.Error });
    }
  } catch (err) {
    dispatch({ type: MOVIE_FAILURE, payload: "Failed to fetch movie details" });
  }
};

export const clearMovie = () => ({ type: CLEAR_MOVIE });
